import config from 'config';
import { ResultWithMessage } from 'models/results/result';
import { User } from 'models/user';
import { User as OidcUser } from 'oidc-client';
import { Pagination, PaginationResult } from 'types/pagination';
import { UserInfo } from 'types/userInfo';
import axios from 'utils/axios';
import { Data, UserFilters } from 'views/users/users';

class UserService {
    async getUserInfo(user: OidcUser): Promise<UserInfo> {
        try {
            axios.defaults.headers.common.Authorization = `Bearer ${user.access_token}`;
            const res = await axios.get<UserInfo>('/GetUserInfo');
            return res.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to fetch user info');
        }
    }

    async getUsersItems(tenantId: string): Promise<User[]> {
        try {
            const res = await axios.post<User[]>('/GetUsersItems', tenantId);
            return res.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to fetch user items');
        }
    }

    async upsertUser(tenantId: string, userId: string, username: string, user: User): Promise<ResultWithMessage<boolean>> {
        try {
            const res = await axios.post<ResultWithMessage<boolean>>('/UpsertUser', {
                tenantId,
                userOfInsertId: userId,
                userOfInsert: username,
                ...user
            });
            return res.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to upsert user');
        }
    }

    async getUserPaginated(tenantId: string, pagination: Pagination, filters: UserFilters<Data>): Promise<PaginationResult<User>> {
        try {
            const result = await axios.post<PaginationResult<User>>('/GetUserPaginated', {
                ...pagination,
                ...filters,
                tenantId
            });
            return result.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to fetch users');
        }
    }

    async getUser(tenantId: string, id: string): Promise<User> {
        try {
            const res = await axios.post<User>('/GetUser', { tenantId, id });
            return res.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to fetch user');
        }
    }
}

export default UserService;
